const checkBoxFontSize = 12;
const fieldFontSize = 14;

export const styles = ({ palette }) => ({
  paperWidthMd: {
    width: '40%',
    overflow: 'visible',
    backgroundColor: palette.background.paper,
  },
  backgroundStyle: {
    backgroundColor: palette.background.paper,
  },
  scrollPaperTablet: {
    alignItems: 'baseline',
  },
  panel: {
    padding: '10px 20px 10px 20px',
    background: palette.background.paper,
    overflow: 'visible',
  },
  textField: {
    '& label.Mui-focused': {
      color: palette.text.strong,
    },
    '& label': {
      color: palette.text.strong,
    },

    '& input': {
      fontSize: fieldFontSize,
      paddingBottom: 4,
      '&::placeholder': {
        color: palette.text.strong,
        opacity: '100%',
      },
    },
  },
  clrSection: {
    display: 'flex',
    alignItems: 'center',
    border: 'none',
    paddingTop: 12,
    backgroundColor: palette.background.paper,
    color: palette.text.strong,
    fontSize: '13px',
    borderRadius: 0,
  },
  editSection: {
    background: palette.background.paper,
    color: palette.text.strong,
    fontSize: '13px',
    height: 56,
    width: '100%',
    borderBottomStyle: 'solid',
    borderRadius: 0,
    borderBottomWidth: 'thin',
    borderColor: palette.background.subtle,
    display: 'flex',
  },
  icon: {
    paddingRight: 12,
    width: '30px',
    alignSelf: 'unset',
    ...(palette.mode === 'dark' && {
      filter: 'invert(1)',
    }),
  },
  splitsContainer: {
    marginBottom: 15,
    marginLeft: 24,
    marginRight: 24,
    backgroundColor: palette.background.paper,
    overflow: 'visible',
  },
  inputLabel: {
    fontSize: fieldFontSize,
    '& label.Mui-focused': {
      color: palette.text.strong,
    },
    '& label': {
      color: palette.text.strong,
    },
    '&::placeholder': {
      color: palette.text.strong,
      opacity: '100%',
    },
  },
  formLabel: {
    height: 20,
    marginLeft: 0,
  },
  checkboxLabel: {
    fontSize: checkBoxFontSize,
    color: palette.text.secondary,
    marginLeft: 5,
  },
  checkbox: {
    fontSize: checkBoxFontSize + 6,
    paddingBottom: 3,
    height: 30,
    marginTop: 10,
  },
  categoryField: {
    fontSize: fieldFontSize,
    '& input': {
      width: '95%',
      paddingBottom: 1,
      '& label.Mui-focused': {
        color: palette.text.strong,
      },
      '& label': {
        color: palette.text.strong,
      },
      '&::placeholder': {
        color: palette.text.strong,
        opacity: '100%',
      },
    },
  },
  categoryFieldSection: {
    background: palette.background.paper,
    color: palette.text.strong,
    fontSize: '15px',
    width: '100% !important',
    display: 'flex',
    height: 56,
    borderBottomStyle: 'solid',
    borderRadius: 0,
    borderBottomWidth: 'thin',
    borderColor: palette.background.subtle,
  },
  buttonHolder: {
    textAlign: 'right',
    margin: 'auto',
    marginTop: '10px',
    background: palette.background.paper,
    padding: 24,
    paddingTop: 0,
  },
  cancelButton: {
    marginRight: 12,
  },
  disclaimer: {
    fontSize: '11px',
    color: palette.text.secondary,
  },
  headerTitle: {
    display: 'flex',
    padding: 24,
    alignItems: 'center',
    backgroundColor: palette.background.layer1,
    justifyContent: 'space-between',
    borderRadius: '8px 8px 0 0',
  },
  closeButtonTop: {
    padding: 0,
  },
});
